import { forwardRef } from 'react';
import cx from 'classnames';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import { renderDesignTokens, useDesignTokens } from '../../theme';
import { Flow } from '../Layouts/Flow';
import bundle from './NovaComponents-BusyStateIndicator-gui-icu.properties';
import cn from './BusyStateAnimationElement.css.json';
import './BusyStateAnimationElement.css';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const BusyStateAnimationElement = /*#__PURE__*/forwardRef(function BusyStateAnimationElement(props, ref) {
  const localize = useTextLocalizer();
  const dt = useDesignTokens();
  const tokens = getBusyStateAnimationDesignTokens(dt, {
    tokens: props.tokens
  });
  return /*#__PURE__*/_jsx(Flow, {
    spacing: "s",
    tabIndex: props.tabIndex ?? 0,
    ref: ref,
    className: cx(cn.barContainer, props.className),
    style: {
      ...tokens,
      ...props.style
    },
    "aria-label": props.ariaLabel ?? localize('busyStateIndicatorAnimation.default.aria'),
    "aria-describedby": props.ariaDescribedBy,
    role: "img",
    title: localize('busyStateIndicatorAnimation.default.tooltip.label'),
    children: /*#__PURE__*/_jsx("div", {
      className: cn.progressBar
    })
  });
});
export const getBusyStateAnimationDesignTokens = (dt, opts) => {
  return {
    ...renderDesignTokens({
      bg: dt.tokens['color-primary'],
      'animation-start': dt.tokens['color-primary'],
      'animation-end': dt.tokens['color-container-background-0'],
      minWidth: dt.tokens['size-container-xs'],
      maxWidth: dt.tokens['size-container-l'],
      'border-radius': dt.tokens['size-border-radius-xxs'],
      height: '4px',
      ...(opts?.tokens?.() ?? {})
    }, 'busy-state-bar'),
    ...(!dt.enableNovaTokens && getBusyStateAnimationLegacyTokens(dt, opts))
  };
};
const getBusyStateAnimationLegacyTokens = (dt, opts) => {
  switch (dt.baseReportThemeName) {
    case 'highcontrast2018':
    case 'highcontrast2017':
      // from https://gitlab.sas.com/dvr/html/resource-archive/blob/master/specs/object-status.pdf
      return {
        ...renderDesignTokens({
          bg: dt.c.hcBusy,
          'animation-start': dt.tokens['color-primary'],
          'animation-end': dt.c.white,
          ...(opts?.tokens?.() ?? {})
        }, 'busy-state-bar')
      };
  }
  return {
    ...renderDesignTokens({
      bg: dt.reportTokens.stateStatusContent.informational.fg,
      'animation-start': dt.tokens['color-primary'],
      'animation-end': dt.c.white,
      ...(opts?.tokens?.() ?? {})
    }, 'busy-state-bar')
  };
};
//# sourceMappingURL=BusyStateAnimationElement.js.map